module.exports = __webpack_public_path__ + "img/llco.368bca91.jpg";